import {
  Box,
  Button,
  Checkbox,
  FileInput,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  rem,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconCircleMinus,
  IconCirclePlus,
  IconFileCv,
  IconMinus,
  IconPlus,
  IconRotateClockwise,
} from "@tabler/icons-react";
import moment from "moment";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatFormData } from "../../../_base/helper/FunctionHelper";
import { createArticleList, getArticleCategory } from "../../../api/ApiArticle";
import { uploadFile } from "../../../api/ApiProduct";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import { ArticleList } from "../../../model/Article";
import { repositoryWeb } from "../../../_base/_const/_constVar";

interface CategoryList {
  catid: number;
}

const CreateArticleReward = ({ onSuccess }: { onSuccess: any }) => {
  const entity = {
    // type: "",
    // title: "",
    // videoCode: "",
    // externalUrl: "",
    // url: "",
    // requestPath: null,
    // urlHash: null,
    // thumnail: "",
    // imageBackground: "",
    // extend: "",
    // summary: "",
    // tags: "",
    // creationDate: null,
    // createdBy: null,
    // lastUpdateDate: null,
    // lastUpdatedBy: null,
    // ordering: null,
    // reviewRate: null,
    // reviewCount: null,
    // status: 2,
    // visit: null,
    // likeCount: null,
    // isFeatured: null,
    // approvedStatus: null,
    // metaTitle: null,
    // metaKeywords: null,
    // metaDescription: null,
    // commentCount: null,
    // commentRate: null,
    // postedDate: "",
    // isStricking: "",
    // content: "",
    // imagePath: "",
    // imageDetailPath: "",
    // articleCategory: "",
    // allowSeIndex: "",
    // tblArticleImageCommands: [],

    type: "",
    title: "",
    videoCode: "",
    externalUrl: "",
    url: "",
    requestPath: "",
    urlHash: "",
    thumnail: "",
    imageBackground: "",
    extend: "",
    summary: "",
    tags: "",
    creationDate: "",
    createdBy: "",
    lastUpdateDate: "",
    lastUpdatedBy: "",
    ordering: "",
    reviewRate: "",
    reviewCount: "",
    status: "",
    visit: "",
    likeCount: "",
    isFeatured: "",
    approvedStatus: "",
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    commentCount: "",
    commentRate: "",
    postedDate: "",
    isStricking: "",
    content: "",
    imagePath: "",
    imageDetailPath: "",
    allowSeIndex: "",
    attribute1: "",
    attribute2: "",
    attribute3: "",
    attribute4: "",
    attribute5: "",
    attribute6: "",
    attribute7: "",
    attribute8: "",
    attribute9: "",
    attribute10: "",
    tblArticleImageCommands: [],
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [valueDescription, setValueDescription] = useState(null);

  const [timeOption, setTimeOption] = useState("now");
  const [dataArcticleCategory, setDataArcticleCategory] = useState<any>();

  // State cho việc xử lý ảnh giống EditView
  const [modalOpened, setModalOpened] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());
  const [selectedItems, setSelectedItems] = useState<CategoryList[]>([]);

  const form = useForm<any>({
    initialValues: {
      ...entity,
    },
    validate: {},
  });

  const handleChangeDataContent = (content: string | null) => {
    let modifiedString = content?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };

  // Hàm xử lý tạo mới bài viết
  const handleCreateArticleList = async (dataSubmit: ArticleList) => {
    if (!dataSubmit.title || dataSubmit.title.length === 0) {
      NotificationExtension.Fails("Vui lòng nhập tiêu đề bài viết !");
      return;
    } else if (!dataSubmit.thumnail || dataSubmit.thumnail.length === 0) {
      NotificationExtension.Fails("Vui lòng chọn ảnh cho bài viết !");
      return;
    } else {
      open();
      if (timeOption === "now") {
        dataSubmit.postedDate = moment().format("YYYY-MM-DD[T]HH:mm:ss");
      }

      // Loại bỏ thumnail và imageBackground khỏi dataSubmit vì sẽ gửi file thật qua FormData
      const { content, ...restData } = form.getValues();

      // Đồng bộ requestPath và url mà không tự sinh từ tiêu đề
      let url = restData.url || "";
      let requestPath = restData.requestPath || "";

      if (url) {
        // Người dùng nhập URL thủ công -> chuẩn hóa và gán requestPath tương ứng
        restData.url = url.replace(/^\//, "");
        restData.requestPath = url.startsWith("/") ? url : `/${url}`;
      } else if (requestPath) {
        // Trường hợp chỉ có requestPath
        restData.requestPath = requestPath.startsWith("/")
          ? requestPath
          : `/${requestPath}`;
        restData.url = restData.requestPath.replace(/^\//, "");
      }

      // Tạo FormData để gửi file binary giống EditView
      const formData = new FormData();

      // Xử lý từng field một cách rõ ràng
      Object.keys(restData).forEach((key) => {
        const value = (restData as any)[key];

        if (value !== null && value !== undefined) {
          if (Array.isArray(value)) {
            // Xử lý array - gửi từng phần tử với index
            value.forEach((item, index) => {
              if (item !== null && item !== undefined) {
                formData.append(`${key}[${index}]`, item.toString());
              }
            });
            console.log(`Array ${key}:`, value); // Debug array
          } else if (typeof value === "object" && !(value instanceof File)) {
            // Xử lý object phức tạp
            formatFormData(value, formData, key);
          } else {
            // Xử lý giá trị đơn giản
            formData.append(key, value.toString());
          }
        }
      });

      // Thêm nội dung đã xử lý
      formData.append("content", handleChangeDataContent(valueDescription));

      // Debug: Kiểm tra dữ liệu FormData
      console.log("FormData được chuẩn bị để gửi:", restData);
      console.log(
        "Content được thêm:",
        handleChangeDataContent(valueDescription)
      );

      try {
        const res = await repositoryWeb.post(
          `/TblArticlePos/create`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (res && res.success) {
          NotificationExtension.Success("Tạo bài viết thành công !");
          onSuccess();
          modals.closeAll();
        } else {
          NotificationExtension.Fails(res.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    }
  };

  // Hàm để toggle expand/collapse danh mục
  const toggleExpanded = (itemId: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  // Hàm đệ quy để render cây danh mục
  const renderCategoryTree = (categories: any[], level: number = 0) => {
    // Chia danh sách categories thành các nhóm 4 mục
    const chunkedCategories = [];
    if (categories) {
      for (let i = 0; i < categories.length; i += 5) {
        chunkedCategories.push(categories.slice(i, i + 5));
      }
    }

    return (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
        {chunkedCategories.map((categoryChunk, columnIndex) => (
          <div
            key={columnIndex}
            style={{ flex: "1 0 auto", minWidth: "200px" }}
          >
            {categoryChunk.map((item: any) => {
              const hasChildren =
                item.tblArticleCategoryModels &&
                item.tblArticleCategoryModels.length > 0;
              const isExpanded = expandedItems.has(item.id);

              return (
                <Box key={item.id}>
                  {/* Render checkbox cho danh mục hiện tại */}
                  <Group
                    gap="xs"
                    wrap="nowrap"
                    style={{ marginLeft: `${level * 20}px` }}
                  >
                    {/* Icon expand/collapse chỉ hiện khi có danh mục con */}
                    {hasChildren ? (
                      <Box
                        style={{
                          cursor: "pointer",
                          minWidth: "20px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => toggleExpanded(item.id)}
                      >
                        {isExpanded ? (
                          <IconCircleMinus size={20} color="#1976d2" />
                        ) : (
                          <IconCirclePlus size={20} color="#1976d2" />
                        )}
                      </Box>
                    ) : (
                      <Box style={{ minWidth: "20px" }} />
                    )}

                    {/* Checkbox */}
                    <Checkbox
                      style={{
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        fontWeight: "normal",
                      }}
                      label={item.name}
                      checked={selectedItems.some(
                        (selectedItem) => selectedItem.catid === item.id
                      )}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                  </Group>

                  {/* Render danh mục con (đệ quy) - chỉ hiện khi expanded */}
                  {hasChildren &&
                    isExpanded &&
                    renderCategoryTree(
                      item.tblArticleCategoryModels,
                      level + 1
                    )}
                </Box>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  // Hàm xử lý chọn danh mục bài viết
  const handleCheckboxChange = (catid: number) => {
    setSelectedItems((prevItems) => {
      const itemIndex = prevItems.findIndex((item) => item.catid === catid);
      if (itemIndex !== -1) {
        const newSelectedItems = [...prevItems];
        newSelectedItems.splice(itemIndex, 1);
        const newArray = newSelectedItems.map((item) => item.catid);
        form.setValues({ listCategoryId: newArray });
        return newSelectedItems;
      } else {
        const newArray = [...prevItems, { catid }];
        form.setValues({ listCategoryId: newArray.map((item) => item.catid) });
        return newArray;
      }
    });
  };

  // Hàm xử lý khi chọn file ảnh thu nhỏ
  const handleImgUrlChange = async (file: File | null) => {
    // Nếu chỉ chọn 1 file, chuyển thành mảng và lọc bỏ null
    const fileArray = Array.isArray(file) ? file : [file];
    const validFiles = fileArray.filter((f): f is File => f !== null);

    if (validFiles.length > 0) {
      const result = await uploadFile(validFiles, "article");
      console.log("Upload result:", result);
      if (result && result.success) {
        form.setFieldValue("thumnail", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh lên thất bại!");
      }
    }
  };

  const fetchDataArticleReward = async () => {
    try {
      open();
      const res = await repositoryWeb.get(`/TblArticlePos/get-create`);
      if (res && res.success) {
        setDataArcticleCategory(res?.data);
      }
      close();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataArticleReward();
  }, []);

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        w={"82.5vw"}
        maw={1350}
        mx={10}
        onSubmit={form.onSubmit((values: ArticleList) => {
          handleCreateArticleList(values);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <>
          {/* <Text size="sm" mt="sm" fw={700}>
            Danh mục (có thể chọn nhiều danh mục)
          </Text>
          <Group grow wrap="wrap" gap={"lg"}>
            <Group grow wrap="wrap" gap={"lg"}>
              <Box>
                {dataArcticleCategory ? (
                  renderCategoryTree(dataArcticleCategory)
                ) : (
                  <p>Không có dữ liệu danh mục</p>
                )}
              </Box>
            </Group>
          </Group> */}
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label={"Tiêu đề"}
                placeholder={"Nhập tiêu đề"}
                withAsterisk
                mt="md"
                type="text"
                {...form.getInputProps("title")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Box
                style={{
                  display: "flex",
                  flex: 1,
                  gap: "1rem",
                }}
              >
                <Select
                  label="Thời gian của bài viết"
                  placeholder="Chọn thời gian "
                  data={[
                    { value: "now", label: "Thời gian tạo bài" },
                    { value: "custom", label: "Chọn thời gian" },
                  ]}
                  value={timeOption}
                  onChange={(val) => setTimeOption(val || "now")}
                  mt="md"
                  style={{
                    flex: 1,
                  }}
                  clearable
                />

                {timeOption === "custom" && (
                  <DateTimePicker
                    {...form.getInputProps("postedDate")}
                    value={
                      form.getInputProps("postedDate").value
                        ? new Date(form.getInputProps("postedDate").value)
                        : null
                    }
                    onChange={(value: any) =>
                      form
                        .getInputProps("postedDate")
                        .onChange(moment(value).format("YYYY-MM-DD[T]HH:mm:ss"))
                    }
                    locale="vi"
                    withAsterisk
                    mt="md"
                    label="Chọn thời gian"
                    placeholder="Thời gian đăng tải"
                    style={{
                      flex: 1,
                    }}
                  />
                )}
              </Box>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <Select
                label={"Trạng thái"}
                placeholder={"Trạng thái"}
                // withAsterisk
                data={[
                  { value: "0", label: "Chờ duyệt" },
                  { value: "1", label: "Cho hiển thị" },
                  { value: "2", label: "Bản nháp" },
                ]}
                {...form.getInputProps("status")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <TextInput
                label={"Thứ tự"}
                placeholder={"Nhập thứ tự"}
                // withAsterisk
                type="number"
                {...form.getInputProps("ordering")}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4 }}>
              <Select
                label={"Nổi bật"}
                placeholder={"Nhập nổi bật"}
                // withAsterisk
                data={[
                  { value: "Y", label: "Nổi bật" },
                  { value: "N", label: "Không nổi bật" },
                ]}
                {...form.getInputProps("isStricking")}
                clearable
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <TextInput
                label={"Url"}
                placeholder={"Nhập url"}
                type="text"
                {...form.getInputProps("url")}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <Box>
                <FileInput
                  leftSection={icon}
                  label="Hình thu nhỏ"
                  placeholder="Chọn tệp..."
                  accept="image/*"
                  leftSectionPointerEvents="none"
                  clearable
                  withAsterisk
                  onChange={handleImgUrlChange}
                />

                <Box
                  mt="sm"
                  style={{
                    border: "2px dashed #e9ecef",
                    borderRadius: "8px",
                    padding: "12px",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                  }}
                >
                  <Text size="xs" c="dimmed" mb="xs">
                    Hình thu nhỏ hiện tại
                  </Text>
                  <Box
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      border: "1px solid #dee2e6",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: 140,
                    }}
                  >
                    {form.getValues().thumnail ? (
                      <img
                        src={form.getValues().thumnail?.toString()}
                        alt="Preview Thumbnail"
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          objectFit: "cover",
                          display: "block",
                          margin: "auto",
                          cursor: "pointer",
                        }}
                        onDoubleClick={() => {
                          setModalImageUrl(
                            form.getValues().thumnail?.toString() || ""
                          );
                          setZoomLevel(1);
                          setModalOpened(true);
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 120,
                          height: 120,
                          minWidth: 120,
                          minHeight: 120,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#f1f3f4",
                          color: "#6c757d",
                          fontSize: "12px",
                        }}
                      >
                        Chưa có ảnh
                      </div>
                    )}
                  </Box>
                </Box>
              </Box>
            </Grid.Col>
          </Grid>
        </>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>

      <Modal
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
          setZoomLevel(1);
        }}
        centered
        size="xl"
        title={
          <Group justify="space-between" style={{ width: "100%" }}>
            <Text fw={600}>Xem chi tiết ảnh</Text>
            <Group gap="xs">
              <Button
                variant="light"
                size="xs"
                leftSection={<IconMinus size={14} />}
                onClick={() =>
                  setZoomLevel((prev) => Math.max(0.25, prev - 0.25))
                }
                disabled={zoomLevel <= 0.25}
              >
                Zoom Out
              </Button>
              <Text size="sm" style={{ minWidth: "60px", textAlign: "center" }}>
                {Math.round(zoomLevel * 100)}%
              </Text>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconPlus size={14} />}
                onClick={() => setZoomLevel((prev) => Math.min(3, prev + 0.25))}
                disabled={zoomLevel >= 3}
              >
                Zoom In
              </Button>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconRotateClockwise size={14} />}
                onClick={() => setZoomLevel(1)}
              >
                Reset
              </Button>
            </Group>
          </Group>
        }
        overlayProps={{ zIndex: 999999 }}
        zIndex={999999}
        styles={{
          body: {
            padding: 0,
            overflow: "auto",
            maxHeight: "80vh",
          },
        }}
        style={{
          maxWidth: "95vw",
          maxHeight: "95vh",
        }}
      >
        {modalImageUrl && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              overflow: "auto",
              backgroundColor: "#f8f9fa",
            }}
          >
            <img
              src={modalImageUrl}
              alt="Ảnh chi tiết"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "center",
                transition: "transform 0.2s ease-in-out",
                maxWidth: "none",
                maxHeight: "none",
                display: "block",
                cursor: zoomLevel < 3 ? "zoom-in" : "zoom-out",
              }}
              onClick={() => {
                if (zoomLevel < 3) {
                  setZoomLevel((prev) => Math.min(3, prev + 0.25));
                } else {
                  setZoomLevel(1);
                }
              }}
            />
          </Box>
        )}
      </Modal>
    </>
  );
};

export default CreateArticleReward;
